export const needsSsoOnboarding = (user) =>
  !!user?.sso && (!user?.call_language || user.call_language === "");
